import PropTypes from 'prop-types';
import { Component } from 'react';
import languageValues from 'utils/LanguageUtils';
import SnackbarUtils from 'utils/SnackbarUtils';
import { FIXED_PRINCIPOS_VALORES } from '../../store/modules/ProjetoReducer';
import { getFileType } from '../../utils/FileUtils';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import { CustomButton } from '../CustomButton';
import EvaluationHistoryModal from '../EvaluationHistoryModal/EvaluationHistoryModal';
import HistoryRoundedIcon from '../Icons/HistoryRoundedIcon';
import NewCustomUploader from '../NewCustomUploader/NewCustomUploader';
import { StepButton } from '../StepButton';
import {
  STEP_BUTTON_ACTION_NEXT,
  STEP_BUTTON_ACTION_PREV,
  STEP_BUTTON_ACTION_SAVE_AND_NEXT,
  STEP_BUTTON_ACTION_SAVE_AND_NEXT_TO_DOWN,
} from '../StepButton/StepButton';
import { Col } from './../Col';
import { Row } from './../Row';
import styles from './GenericProjectCard.scss';

const rootClassName = styles.rootClassName;

class GenericProjectCard extends Component {
  constructor(props) {
    super(props);

    this.toPrev = this.toPrev.bind(this);
    this.toNext = this.toNext.bind(this);
  }
  itemsAreValid(items) {
    return items.indexOf(false) === -1;
  }

  getPreviousButton(isValid) {
    const btnProps = {
      className: rootClassName + '-full-mobile-button',
      theme: 'pufvYellow',
      action: STEP_BUTTON_ACTION_PREV,
      disabled: !isValid,
      onClick: () => {
        this.toPrev();
      },
    };
    return <StepButton {...btnProps} />;
  }

  getNextButton(isValid) {
    const btnProps = {
      className: rootClassName + '-full-mobile-button',
      theme: 'pufvYellow',
      type: 'submit',
      action: STEP_BUTTON_ACTION_NEXT,
      disabled: !isValid,
    };
    return <StepButton {...btnProps} />;
  }

  getSaveAndNextButton(isValid, actionCallback) {
    const btnProps = {
      className: rootClassName + '-full-mobile-button',
      theme: 'pufvYellow',
      type: 'submit',
      action: STEP_BUTTON_ACTION_SAVE_AND_NEXT,
      disabled: !isValid,
      onClick: () => {
        actionCallback();
      },
    };
    return <StepButton {...btnProps} />;
  }

  toPrev() {
    this.props.toPrevStep();
  }

  toNext() {
    this.props.toNextStep();
  }

  getUploaderButton(
    buttonLabel,
    counter,
    disabled,
    customUploaderProps,
    openModal
  ) {
    customUploaderProps = {
      ...customUploaderProps,
      getNewFileObject: (file) => {
        return {
          filesLimit: 3,
          caminho: null,
          cooperativa: customUploaderProps.cooperativa,
          etapa: customUploaderProps.etapa,
          id: -1,
          idProjeto: customUploaderProps.idProjeto,
          principal: false,
          tipo: getFileType(file.name),
          file: file,
          titleHint: customUploaderProps.titleHint || null,
        };
      },
      onTypeMismatch: () => {
        SnackbarUtils.enqueueSnackbar({
          message: languageValues.toasts.error.fileType,
          options: {
            variant: 'error',
          },
        });
      },
      acceptedTypes: ['.png', '.jpg', '.jpeg', '.mp4'],
    };
    return (
      <CustomButton
        className={rootClassName + '-full-mobile-button'}
        disabled={disabled}
        theme='pufvYellow'
        counter={counter}
        label={buttonLabel}
        onClick={() => {
          openModal(NewCustomUploader, customUploaderProps);
        }}
      />
    );
  }

  getHistoryButton(buttonLabel, modalTitle, history, stepIndex, openModal) {
    return (
      <CustomButton
        theme='pufvYellow'
        className={rootClassName + '-full-mobile-button'}
        counter={history.length}
        label={buttonLabel}
        rightIcon={<HistoryRoundedIcon />}
        disabled={history && history.length > 0 ? false : true}
        onClick={() => {
          openModal(EvaluationHistoryModal, {
            stepIndex: stepIndex,
            title: modalTitle,
            history: history || [],
          });
        }}
      />
    );
  }

  getFinalyButton(disabled, actionCallback) {
    const btnProps = {
      className: rootClassName + '-full-mobile-button',
      theme: 'pufvYellow',
      type: 'submit',
      action: STEP_BUTTON_ACTION_SAVE_AND_NEXT_TO_DOWN,
      disabled,
      onClick: typeof actionCallback === 'function' ? actionCallback : null,
    };
    return <StepButton {...btnProps} />;
  }

  getActionsRow(actions) {
    return actions.length > 0
      ? actions.map((row, rowIndex) => {
          return (
            <Row
              className={getMergedClassNames([
                rootClassName + '-actions-row',
                rowIndex === 0 ? rootClassName + '-first-actions-row' : '',
                'form-row',
              ])}
              key={rowIndex}
            >
              {row.map((col, colIndex) => {
                return (
                  <Col
                    cols={[12, 6, 6, 6, 6]}
                    className={getMergedClassNames([
                      rootClassName +
                        (colIndex === 0 ? '-left-actions' : '-right-actions'),
                      !col ? rootClassName + '-empty-col' : '',
                    ])}
                    key={colIndex}
                  >
                    {col}
                  </Col>
                );
              })}
            </Row>
          );
        })
      : '';
  }

  getFormClasses(sending) {
    return (
      rootClassName + '-form' + (sending ? rootClassName + '-form-sending' : '')
    );
  }

  setValue(event, callbackSuccess, callbackError) {
    const name = event.target.name;
    if (name === 'idPrincipiosValores') {
      if (
        event.target.value[0] !== FIXED_PRINCIPOS_VALORES[0] ||
        event.target.value[1] !== FIXED_PRINCIPOS_VALORES[1]
      ) {
        if (typeof callbackError === 'function') {
          return callbackError();
        }
      }
      if (
        event.target.value.length < 2 ||
        event.target.value[0] !== FIXED_PRINCIPOS_VALORES[0] ||
        event.target.value[1] !== FIXED_PRINCIPOS_VALORES[1]
      ) {
        event.target.value = [
          ...FIXED_PRINCIPOS_VALORES,
          ...event.target.value,
        ];
      }
    }
    this.props.changeProjetoValue(name, event.target.value);
  }

  mergeFiles(oldList, newList ) {
    this.props.changeProjetoValue('documentos', newList);
  }

  render() {
    return <div className={rootClassName}>{this.props.children}</div>;
  }
}

GenericProjectCard.propTypes = {
  toNextStep: PropTypes.func,
  toPrevStep: PropTypes.func,
};

export default GenericProjectCard;
